import {
  StoreEnum,
  useStore
} from '@myorg/shared';

export default function Footer() {
  const css = `
    .footer {
      background: #fff;
      width: 100%;
      color: #fff;
      font-family: Kanit, sans-serif;
      position: relative;
      //margin-top: 100px;
   }
    .footer .secondary-button {
      border: 2px solid #1f446e;
      color: #1f446e !important;
   }
    .footer .white-button {
      color: white !important;
      cursor: pointer;
      margin-left: 10px;
      margin-right: 10px;
      font-size: 1rem;
      text-decoration: none;
      font-weight: 400;
   }
    .footer .white-button:hover {
      text-decoration: underline;
   }
    .footer .a-custom-button {
      cursor: pointer;
      padding: 22px 0;
      text-align: center;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 500;
      background-color: transparent;
      width: 100%;
      box-sizing: border-box;
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      display: block;
      padding-left: 20px;
      padding-right: 20px;
      color: #1f446e;
      text-decoration: none;
   }
    .footer .a-custom-button:hover {
      text-decoration: underline;
   }
    .footer .footer-shape {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      width: 100%;
      transform: translateY(-100%);
      height: 30px;
   }
    .footer .footer-shape-mobile {
      display: none;
   }
    .footer .footer-top-colored-container {
      background: linear-gradient(to right top, #f44f30 0%, #f57430 60%, #f6923c 100%);
      height: 10px;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
   }
    .footer .footer-content {
      display: flex;
      align-items: stretch;
      padding-left: calc(6vw - 50px);
      padding-right: calc(6vw - 50px);
      height: 100%;
      align-content: stretch;
      justify-content: flex-start;
      padding-top: 50px;
      padding-bottom: 50px;
   }
    .footer .footer-content .footer-element {
      flex: 1;
      padding-left: 50px;
      padding-right: 50px;
      color: #1f446e;
   }
    .footer .footer-content .footer-element.contact-us-element {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
   }
    .footer .footer-content .footer-element.last-footer-element {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;
   }
    .footer .footer-content .footer-element.last-footer-element .last-footer-element-inner {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
   }
    .footer .footer-content .footer-element.last-footer-element .last-footer-element-inner .social-icons-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-end;
   }
    .footer .footer-content .footer-element.last-footer-element .last-footer-element-inner .social-icons-wrapper a {
      cursor: pointer;
      margin-left: 8px;
   }
    .footer .footer-content .footer-element.last-footer-element .last-footer-element-inner .social-icons-wrapper a img {
      width: 41px;
      height: 41px;
   }
    .footer .footer-content .footer-element .footer-element-header {
      font-size: 18px;
      text-transform: uppercase;
      font-weight: 800;
      margin-bottom: 20px;
      color: #1f446e;
      width: auto;
   }
    .footer .footer-content .footer-element .footer-content-link {
      display: block;
      color: #1f446e;
      cursor: pointer;
      margin-bottom: 20px;
      text-decoration: none;
   }
    .footer .footer-content .footer-element .footer-content-link:hover {
      text-decoration: underline;
   }
    .footer .footer-bottom-content {
      padding-left: 6vw;
      padding-right: 6vw;
      color: #fff;
      background: #1f446e;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 25px;
      padding-bottom: 25px;
   }
    .footer .footer-bottom-content .footer-links {
      display: flex;
      align-items: center;
   }
    .footer .footer-bottom-content .footer-links a {
      color: #fff;
      cursor: pointer;
   }
    .footer .footer-bottom-content .footer-links a a:hover {
      color: #fff;
      text-decoration: underline;
   }
    .footer .footer-bottom-content .footer-links span {
      color: #fff;
   }
    .footer .footer-bottom-content .footer-links a, .footer .footer-bottom-content .footer-links span {
      margin-left: 10px;
   }
    .footer p.copyright {
      display: inline-block;
      width: auto;
      margin: 0;
      padding: 0;
      font-size: 18px;
   }
   .footer-delimiter {
    width: 100%;
    height: 10px;
    margin-top: -10px;
    background: #1f446e;
   }
    @media only screen and (max-width: 1250px) {
      .footer {
       margin-top: 30px;
     }
      .footer-shape {
        display: none !important;
     }
      .footer-shape-mobile {
        display: block !important;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 20px;
        transform: translateY(-100%);
     }
      .footer-content {
        flex-direction: column;
        padding-left: 24px !important;
        padding-right: 24px !important;
        padding-top: 20px !important;
        padding-bottom: 20px !important;
     }
      .footer-content .footer-element {
        padding: 0 !important;
        margin-top: 20px;
        margin-bottom: 20px;
     }
      .footer-content .contact-online-text {
        font-size: 14px;
        line-height: 17px;
        font-weight: 300;
        margin-bottom: 7px !important;
        margin-right: 10px;
     }
      .footer-content .footer-element-header {
        margin-bottom: 5px !important;
        display: block;
        font-size: 12px !important;
        font-weight: 800 !important;
        line-height: 15px;
     }
      .footer-content .footer-content-link {
        font-size: 14px;
        line-height: 17px;
        font-weight: 300;
        margin-bottom: 7px !important;
        margin-right: 10px;
     }
      .footer-content .a-custom-button {
        width: auto;
        display: inline-block;
        margin-top: 20px;
     }
      .footer-content .contact-us-element {
        display: block !important;
     }
      .footer-content .social-icons-wrapper {
        margin-bottom: 20px;
     }
      .footer-content .social-icons-wrapper img {
        width: 26px !important;
        height: 26px !important;
     }
      .footer .footer-bottom-content {
        flex-direction: column;
        padding-top: 15px;
        padding-bottom: 15px;
     }
      .footer .footer-bottom-content .footer-links {
        flex-direction: column;
        margin-top: 30px;
     }
      .footer .footer-bottom-content .footer-links a {
        font-size: 14px !important;
        font-weight: 300 !important;
        margin: 0 !important;
        margin-bottom: 2px !important;
        margin-top: 2px !important;
     }
      .footer .footer-bottom-content .footer-links span {
        display: none;
     }
      .footer .footer-bottom-content .p.copyright {
        font-size: 14px !important;
     }
      .last-footer-element .a-custom-button {
        margin: 0 !important;
     }
     .footer-delimiter{
      display: none;
     }
   }
    `;

  const userStore = useStore(StoreEnum.UserStore);
  const resourcesUrl = import.meta.env.REACT_APP_RESOURCES_URL;
  const pagesUrl = import.meta.env.REACT_APP_PAGES_URL;


  return (
    <>
      <style>{css}</style>
      <footer id="footer" role="contentinfo" className="footer">
        <div className='footer-delimiter'></div>
        <div className="footer-content">
          <div className="footer-element">
            <p className="footer-element-header">
              CONTACT
            </p>

            <a href="http://www.premierenergy.info" target="_blank" className="footer-content-link">
              www.premierenergy.info
            </a>

            <p className="contact-online-text">
              0251 929
            </p>
            <a href="mailto:contact.clienti@premierenergy.ro" className="footer-content-link">
              contact.clienti@premierenergy.ro
            </a>

            {/* <a href="https://www.anre.ro" target="_blank" className="footer-content-link" >
              Autoritatea Nationala de Reglementare in domeniul Energiei (ANRE)
            </a>

            <a href="https://anpc.ro/" target="_blank" className="footer-content-link">
              Autoritatea Nationala pentru Protectia Consumatorilor (ANPC)
            </a>
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" className="footer-content-link" >
              <img src={`${resourcesUrl}/pictogramaSOL.png`} style={{width: '200px'}}></img>
            </a>
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" className="footer-content-link" >
              <img src={`${resourcesUrl}/SAL-PICTOGRAMA.png`} style={{width: '200px'}}></img>
            </a> */}
          </div>

          {/* <div className="footer-element">
            <p className="footer-element-header">
              UTILE
            </p>

            <a href={`${pagesUrl}/intrebari-frecvente`} className="footer-content-link" target="_blank">
              Intrebari frecvente
            </a>

            <a href={`${pagesUrl}/documente-utile`} className="footer-content-link" target="_blank">
              Documente utile
            </a>

            <a href={`${pagesUrl}/harta-centrelor-de-relatii-cu-clientii`} className="footer-content-link" target="_blank">
              Harta centrelor de relatii cu clientii Premier Energy Furnizare
            </a>

            <a href={`${pagesUrl}/modalitati-de-plata`} className="footer-content-link" target="_blank">
              Modalitati de plata factura
            </a>
          </div> */}

          {/* <div className="footer-element contact-us-element">
            <div>
              <p className="footer-element-header">
                CONTACTEAZA-NE ONLINE
              </p>

              <p className="contact-online-text">
                Suntem aici pentru tine. Contacteaza-ne si iti vom raspunde in cel mai scurt timp.
              </p>
            </div>

            <a href="https://www.premierenergy.info/contact/" target="_blank" className="a-custom-button secondary-button">
              TRIMITE-NE UN MESAJ
            </a>
          </div> */}
{/* 
          <div className="footer-element last-footer-element">
            <div className="last-footer-element-inner">
              <p className="footer-element-header">
                NE GASESTI PE
              </p>

              <div className="social-icons-wrapper">
                <a href="https://www.facebook.com/premierenergyromania" target="_blank" className="social-icon">
                  <img src={`${resourcesUrl}ui/facebook-footer-icon.png`} />
                </a>

                <a href="https://www.instagram.com/premierenergyromania/" style={{ marginLeft: '8px' }} target="_blank" className="social-icon">
                  <img src={`${resourcesUrl}ui/instagram-footer-icon.png`} />
                </a>

                <a href="https://www.youtube.com/@Premier.Energy" style={{ marginLeft: '8px' }} target="_blank" className="social-icon">
                  <img src={`${resourcesUrl}ui/youtube-footer-icon.png`}/>
                </a>

                <a href="https://www.tiktok.com/@premier.energy" target="_blank" style={{ marginLeft: '8px' }} className="social-icon">
                  <img src={`${resourcesUrl}ui/tiktok-footer-icon.png`}/>
                </a>

                <a href="https://www.linkedin.com/company/premier-energy-romania/" target="_blank" style={{ marginLeft: '8px' }} className="social-icon">
                  <img src={`${resourcesUrl}ui/linkedin-footer-icon.png`} />
                </a>
              </div>
            </div>

            {
              userStore.user ? (
                <></>
              ) : (
                <div className="last-footer-element-inner">
                  <p className="footer-element-header">
                    FII MEREU LA CURENT
                  </p>
                  <a href="https://mycez.cezinfo.ro/web/guest/abonare-newsletter" target="_blank" className="a-custom-button secondary-button">
                    NEWSLETTER CEZ VANZARE
                  </a>
                </div>
              )
            }


          </div> */}
        </div>
        <div className="footer-bottom-content">
          <p className="copyright">&copy; Premier Energy Furnizare {new Date().getFullYear()} </p>

          <div className="footer-links" >
            {/* <a href="https://mycez.cezinfo.ro/web/guest/politica-de-confidentialitate" className='white-button' target="_blank">
              Politica confidentialitate
            </a>
            <span>|</span>
            <a href="https://cezinfo.ro/cookies" className='white-button' target="_blank">
              Politica Cookies
            </a>
            <span>|</span> */}
            <a href={`${pagesUrl}t-c-subventii`} className='white-button' target="_blank">
              Termeni si conditii
            </a>
          </div >
        </div >
      </footer >
    </>
  );
}
